<c3-config-section-box
  [title]="TP_SECTIONS_INFO['physical-activity'].label"
  [icon]="TP_SECTIONS_INFO['physical-activity'].icon"
>
  <p config-description>{{ TP_SECTIONS_INFO["physical-activity"].description }}</p>

  <div [c3ConfigForm]="this">
    <app-not-yet-implemented></app-not-yet-implemented>
  </div>
</c3-config-section-box>
